import { Col, Row } from "antd";
import { SubmitButton, TextComponent } from "../../../../../../components";
import RoomImage from "../../../../../../assets/RoomImage.png";
import styles from "./UploadImage.module.css";

const UploadImage = () => {
  return (
    <Row className={styles.mainRow}>
      <Col xs={24} md={12} lg={8}>
        <Row className={styles.contentRow}>
          <Col>
            <TextComponent textClass={styles.title}>Upload Image</TextComponent>
          </Col>
          <Col>
            <TextComponent textClass={styles.desc}>
              Upload event venue picture, which showcase venue area.
            </TextComponent>
          </Col>
          <Col>
            <img src={RoomImage} alt="" className={styles.img} />
          </Col>
          <Col>
            <SubmitButton title="Upload Image" />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default UploadImage;
